import { useOktaAuth } from '@okta/okta-react';

export function useAuthToken() {
  const { authState } = useOktaAuth();

  return authState && authState.accessToken
    ? authState.accessToken.accessToken
    : '';
}
